import React, { useState } from "react";
import { notification } from "antd";
import { apiRequest } from "util/services";
import Representation from './Representation';
import i18n from 'i18next';

const Modal = ({ user, showModal, setShowModal, getSubscribtionStatus }) => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [subdomain, setDomain] = useState("");

  const onSubmit = async () => {
    const payload = {
      firebase_id: user.uid,
      zendesk_subdomain: subdomain,
      zendesk_email: email,
      zendesk_tickets_token: token,
    }
    const result = await apiRequest("users/add_zendesk_tickets_keys", "POST", payload, true);
    if (result && !result.error) {
      notification.success({
        message: i18n.t("notifications.115"),
      });
      getSubscribtionStatus();
    } else {
      notification.error({ message: result.error });
    }
    setShowModal(false);
  }

  return <Representation
    setEmail={setEmail}
    setToken={setToken}
    setDomain={setDomain}
    onSubmit={onSubmit}
    showModal={showModal}
    setShowModal={setShowModal}
  />
}

export default Modal;